document.addEventListener("turbo:load", function () {
  const passwordSelectors = "input#user_password, input#admin_password";

  function updatePasswordStrength(input) {
    let score = 0;
    const password = $(input).val();

    const descriptions = [
      "Too short",
      "Weak",
      "Weak",
      "Good",
      "Strong",
      "Best"
    ];

    $("#pwd_strength_wrap").fadeIn(400);

    // Password length
    if (password.length >= 8) {
      $("#length").removeClass("invalid").addClass("valid");
      score++;
    } else {
      $("#length").removeClass("valid").addClass("invalid");
    }

    if (/\d/.test(password)) {
      $("#pnum").removeClass("invalid").addClass("valid");
      score++;
    } else {
      $("#pnum").removeClass("valid").addClass("invalid");
    }

    if (/[!@#$%^&*?._~\\\-()]/.test(password)) {
      $("#spchar").removeClass("invalid").addClass("valid");
      score++;
    } else {
      $("#spchar").removeClass("valid").addClass("invalid");
    }

    if (/[A-Z]/.test(password) && /[a-z]/.test(password)) {
      $("#capital-small").removeClass("invalid").addClass("valid");
      score++;
    } else {
      $("#capital-small").removeClass("valid").addClass("invalid");
    }

    // Show strength
    if (password.length > 0) {
      $("#passwordDescription").text(descriptions[score]);
    } else {
      $("#passwordDescription").text("Password not entered");
    }

    $("#passwordStrength")
      .removeClass()
      .addClass(`strength${score}`);
  }

  $(document).on("focus keyup", passwordSelectors, function () {
    updatePasswordStrength(this);

    if (this.id === "user_password") {
      $("#user_password-error").addClass("d-none");
    }
  });

  $(document).on("focusout", passwordSelectors, function () {
    $("#pwd_strength_wrap").fadeOut(400);

    if (this.id === "user_password") {
      $("#user_password-error").removeClass("d-none");
    }
  });
});
